<h2 mat-dialog-title>Capture</h2>
<mat-dialog-content>
    <div *ngIf="capturing">
        <video #videoElement autoplay></video>
        <br>
        <!-- <button (click)="startCamera()">Start Camera</button> -->
        <div class="text-center">
            <button mat-raised-button color="primary" (click)="captureImage()" class="mr-1">Capture Image</button>
        <!-- <button mat-stroked-button color="primary" (click)="captureVideo()">Capture Video</button> -->
        </div>
    </div>
    <canvas #canvasElement style="display:none;"></canvas>
    <div *ngIf="imageCaptured">
        <div class="d-flex full-width justify-content-between">
            <h3>Captured Image:</h3>
            <button mat-button (click)="startCamera()"><mat-icon>close</mat-icon></button>
        </div>
        <div>
            <img [src]="capturedImage" *ngIf="capturedImage">
        </div>
        <div class="text-center">
            <button mat-stroked-button color="primary" class="mr-2" (click)="startCamera()">Cancel</button>
            <button mat-raised-button color="primary" (click)="uploadImage()">Upload this picture</button>
            <!-- <button mat-stroked-button><mat-icon color="primary">check</mat-icon> Upload image</button> -->
        </div>
    </div>
    <!-- <div *ngIf="videoCaptured">
        <h3>Captured Video:</h3>
        <video [src]="capturedVideo" controls *ngIf="capturedVideo"></video>
    </div> -->
</mat-dialog-content>